import React, { useState, useRef } from 'react';

/**
 * Tooltip — hover tooltip for any element.
 * Usage: <Tooltip text="Click to delete"><button>✕</button></Tooltip>
 */
export default function Tooltip({ text, children, placement = 'top', delay = 200 }) {
  const [visible, setVisible] = useState(false);
  const timer = useRef(null);

  const show = () => { timer.current = setTimeout(() => setVisible(true), delay); };
  const hide = () => { clearTimeout(timer.current); setVisible(false); };

  const posStyles = {
    top:    { bottom:'calc(100% + 7px)', left:'50%', transform:'translateX(-50%)' },
    bottom: { top:'calc(100% + 7px)',    left:'50%', transform:'translateX(-50%)' },
    left:   { right:'calc(100% + 7px)', top:'50%',  transform:'translateY(-50%)' },
    right:  { left:'calc(100% + 7px)',  top:'50%',  transform:'translateY(-50%)' },
  };

  return (
    <span style={{ position:'relative', display:'inline-flex', alignItems:'center' }}
      onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide}>
      {children}
      {visible && text && (
        <span style={{
          position:'absolute', zIndex:9999, pointerEvents:'none',
          background:'#1e293b', color:'#fff', padding:'5px 10px',
          borderRadius:6, fontSize:11, fontWeight:500, whiteSpace:'nowrap',
          boxShadow:'0 4px 12px rgba(0,0,0,0.35)',
          ...posStyles[placement],
        }}>
          {text}
          {/* Arrow */}
          <span style={{
            position:'absolute',
            ...(placement==='top'    ? { top:'100%', left:'50%', transform:'translateX(-50%)', borderLeft:'5px solid transparent', borderRight:'5px solid transparent', borderTop:'5px solid #1e293b' } :
                placement==='bottom' ? { bottom:'100%', left:'50%', transform:'translateX(-50%)', borderLeft:'5px solid transparent', borderRight:'5px solid transparent', borderBottom:'5px solid #1e293b' } :
                placement==='left'   ? { left:'100%', top:'50%', transform:'translateY(-50%)', borderTop:'5px solid transparent', borderBottom:'5px solid transparent', borderLeft:'5px solid #1e293b' } :
                                       { right:'100%', top:'50%', transform:'translateY(-50%)', borderTop:'5px solid transparent', borderBottom:'5px solid transparent', borderRight:'5px solid #1e293b' }),
          }} />
        </span>
      )}
    </span>
  );
}
